// Module
var code = "<div class=\"ui-grid-cell-contents u-sizeFullWidth u-textRight\" ng-bind=\"::row.entity.ownerLabel\">\n</div>\n";
// Exports
module.exports = code;